import { z } from "zod";
import { Uuid,IsoDateTime,success } from "@secretaa/http-contract";
const Revision=z.number().int().nonnegative().max(2147483647);
export const Command=z.discriminatedUnion("action",[
 z.object({action:z.literal("TICK"),workspaceId:Uuid}).strict(),
 z.object({action:z.literal("CALL"),workspaceId:Uuid,subjectId:Uuid,callId:Uuid}).strict(),
 z.object({action:z.literal("PAGE"),workspaceId:Uuid,afterId:Uuid.nullable(),limit:z.number().int().min(1).max(10)}).strict(),
]);
export type Command=z.infer<typeof Command>;
const SettledStatus=z.enum(["SETTLED","NO_DISPATCH","PENDING"]);
const Item=z.union([
 z.object({callId:Uuid,status:SettledStatus,revision:Revision}).strict(),
 z.object({callId:Uuid,status:z.literal("RETRY"),code:z.enum(["NOT_FOUND","VERSION_CONFLICT","PERMISSION_DENIED","TEMPORARY_FAILURE"])}).strict(),
]);
export const TickResult=z.object({kind:z.literal("TICK"),workspaceId:Uuid,status:z.enum(["IDLE","DEFERRED","PROCESSED"]),revision:Revision,processed:z.number().int().min(0).max(1),pending:z.number().int().min(0).max(1),nextAttemptAt:IsoDateTime.nullable()}).strict()
export const Result=z.discriminatedUnion("kind",[
 TickResult,
 z.object({kind:z.literal("CALL"),workspaceId:Uuid,subjectId:Uuid,callId:Uuid,status:SettledStatus,revision:Revision}).strict(),
 z.object({kind:z.literal("PAGE"),workspaceId:Uuid,results:z.array(Item).max(10),nextAfterId:Uuid.nullable()}).strict(),
]).refine(r=>r.kind!=="TICK" || (r.pending<=r.processed && (r.status==="PROCESSED"?r.processed===1:r.processed===0) && (r.revision===0 || r.nextAttemptAt!==null)),"SWEEP_RESULT_INVALID");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/api/internal/v1/ai-accounting";
export const CONTRACT_VERSION="1.1.0";
